import DesktopView from 'layouts/Desktop/containers/Map'
import Controller from './Controller'
import MobileView from './MobileView'
import Popups from './Popups'
import './style.scss'

const Maps = ({ isMobile = true }) => {
  return (
    <>
      <Controller />
      <Popups />
      {isMobile ? <MobileView /> : <DesktopView />}
    </>
  )
}

export default Maps